import { produce } from "immer";

import { rootInitialState } from "./rootReducer";

type RootInitialState = typeof rootInitialState;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadLocalStorage = (): any => {
  try {
    const serializedState = localStorage.getItem("tagging-redux");
    if (serializedState === null) {
      return undefined;
    }
    const json = JSON.parse(serializedState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const state = produce(json, (draft: any) => {
      // Remove any deprecated properties
      if (draft.settings && "gameType" in draft.settings) {
        delete draft.settings.gameType;
      }
    });

    const validationArray = [
      "battingPractice",
      "bullpen",
      "game",
      "session",
      "settings",
    ];
    if (!Object.keys(json).every((elem) => validationArray.includes(elem))) {
      return {
        ...rootInitialState,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        settings: (state as any).settings,
      };
    }

    return state;
  } catch {
    console.error("[Tagging] Error loading state from localStorage");
    return undefined;
  }
};

export const saveToLocalStorage = (state: Partial<RootInitialState>) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("tagging-redux", serializedState);
  } catch {
    console.error("[Tagging] Error saving state to localStorage");
  }
};
